import countriesToCities from './countries-cities.min.json';

export const getCountriesList = (): readonly string[] => Object.keys(countriesToCities);

export const getCitiesByCountryName = (
  name: keyof typeof countriesToCities,
): readonly string[] => (countriesToCities[name] ? [...countriesToCities[name]] : []);
